import { Loader } from '@servicetitan/web-components';
import { Stack } from '@servicetitan/design-system';
import { observer } from 'mobx-react';
import { FC, useEffect, useState } from 'react';
import { FeBundleStore } from './common/stores/fe-bundle.store';
import { useDependencies } from '@servicetitan/react-ioc';

export const MFEPage: FC = observer(() => {
    const [{ init, bundleUrl, isError }] = useDependencies(FeBundleStore);
    const [estimateId, setEstimateId] = useState<string | null>(null);

    useEffect(() => {
        const search = window.location.hash.split('?')[1];
        const params = new URLSearchParams(search);
        const isPilot = params.get('isPilot') === '1';

        setEstimateId(params.get('estimateId'));

        init(isPilot);
    }, [init]);

    return (
        <Stack direction="column" className="h-100vh">
            {bundleUrl && <Loader src={bundleUrl} data={{ estimateId }} className="h-100" />}
            {isError && <div>Error loading the bundle.</div>}
        </Stack>
    );
});
